export const unwrap = {
    inserted: function (el) {
        const container = el.querySelector("p");
        el.innerHTML = container.innerHTML;
    }
};
